import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function PercentIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M15.8334 4.16699 4.16675 15.8337M5.41659 7.49967c1.15059 0 2.08333-.93274 2.08333-2.08333 0-1.15059-.93274-2.08333-2.08333-2.08333-1.1506 0-2.08334.93274-2.08334 2.08333 0 1.15059.93274 2.08333 2.08334 2.08333ZM14.5833 16.6667c1.1506 0 2.0834-.9328 2.0834-2.0834 0-1.1506-.9328-2.0833-2.0834-2.0833-1.1506 0-2.0833.9327-2.0833 2.0833 0 1.1506.9327 2.0834 2.0833 2.0834Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
